import type { Release } from '../../../types';

const purity: Release = {
  name: 'purity (... and the beast)',
  short_description: 'Conceptual Ambient & Experimental IDM Album',
  description:
    "Purity (... and the beast) is an ambitious 7-track concept album exploring the contrast between serene, minimalist melodies and raw, distorted electronic forces. From the morning stillness of 'latency morning' and 'pixeled memories' to the surging intensity of 'beast' and '... and in time we meet again', the album showcases joev's expansive sound design and cinematic storytelling.",
  tracklist: [
    {
      trackname: 'latency morning',
      duration: '05:37 min',
      tracknr: '01',
      directLink: {
        bandcamp: 'https://joev.bandcamp.com/track/latency-morning',
      },
    },
    {
      trackname: 'pixeled memories',
      duration: '03:44 min',
      tracknr: '02',
      directLink: {
        bandcamp: 'https://joev.bandcamp.com/track/pixeled-memories',
      },
    },
    {
      trackname: 'happy wake up',
      duration: '03:34 min',
      tracknr: '03',
      directLink: {
        bandcamp: 'https://joev.bandcamp.com/track/happy-wake-up',
      },
    },
    {
      trackname: 'beast',
      duration: '04:37 min',
      tracknr: '04',
      directLink: {
        bandcamp: 'https://joev.bandcamp.com/track/beast',
      },
    },
    {
      trackname: 'redeem',
      duration: '07:07 min',
      tracknr: '05',
      directLink: {
        bandcamp: 'https://joev.bandcamp.com/track/redeem',
      },
    },
    {
      trackname: 'counting seconds',
      duration: '04:24 min',
      tracknr: '06',
      directLink: {
        bandcamp: 'https://joev.bandcamp.com/track/counting-seconds',
      },
    },
    {
      trackname: '... and in time we meet again',
      duration: '07:11 min',
      tracknr: '07',
      directLink: {
        bandcamp: 'https://joev.bandcamp.com/track/and-in-time-we-meet-again',
      },
    },
  ],
  date: '09-2017',
  bgColor: '#696969',
  cover: 'joevnoise_purity-and-the-beast.png',
  detail_link: 'purity-and-the-beast',
  links: [
    {
      bandcamp: 'https://joev.bandcamp.com/album/purity-and-the-beast',
    },
    {
      soundcloud: 'https://soundcloud.com/joevnoise/sets/purity_and_the_beast',
    },
  ],
};

export default purity;
